import createSagaMiddleware from "redux-saga";
import { configureStore } from "@reduxjs/toolkit";
import rootReducers from "./reducers";
import rootSaga from "./sagas";
import logger from "redux-logger";
import { promiseMiddleware } from "@adobe/redux-saga-promise";

export const sagaMiddleware = createSagaMiddleware();
const middleware = [promiseMiddleware, sagaMiddleware];

if (process.env.REACT_APP_ENABLE_REDUX_LOGGER === "true") {
  middleware.push(logger);
}

export const store = configureStore({
  reducer: rootReducers,
  middleware: () => middleware,
});

sagaMiddleware.run(rootSaga);
